export default __webpack_public_path__ + "static/media/spin3.f3289ae2.png";